import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens, Text, Link } from '@hotjar/hotsauce';

type Props = {
  totalActions: number;
  resetFilters: () => void;
};

const StyledContainer = styled.div`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x2} ${tokens.spacer.x1};
  background-color: ${tokens.color.neutral_100};
`;

const StyledFeedback = styled(Text)`
  margin-top: ${tokens.spacer.x1};
  margin-bottom: ${tokens.spacer.x3};
`;

export const EmptyFiltersFeedback = ({ totalActions, resetFilters }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledFeedback as="p" textType="caption">
        {t('common:player.actions-list.filtered.empty-state')}
      </StyledFeedback>
      <Text as="p" textType="caption">
        <Link as="button" kind="inline" onClick={resetFilters}>
          {t('common:player.actions-list.filtered.view-other', { count: totalActions })}
        </Link>
      </Text>
    </StyledContainer>
  );
};
